import { useSelector } from 'react-redux';

const get = (server, user, key) => {
  if (server && user) {
    if (user.administrator) {
      return false;
    }
    if (server.forceSettings) {
      return server.attributes[key] || user.attributes[key] || false;
    }
    return user.attributes[key] || server.attributes[key] || false;
  }
  return false;
};

export default () => useSelector((state) => {
  const { server, user } = state.session;

  const disableAttributes = get(server, user, 'ui.disableAttributes');
  const disableVehicleFeatures = get(server, user, 'ui.disableVehicleFeatures');
  const disableDrivers = disableVehicleFeatures || get(server, user, 'ui.disableDrivers');
  const disableMaintenance = disableVehicleFeatures || get(server, user, 'ui.disableMaintenance');
  const disableGroups = get(server, user, 'ui.disableGroups');
  const disableEvents = get(server, user, 'ui.disableEvents');
  const disableComputedAttributes = get(server, user, 'ui.disableComputedAttributes');
  const disableCalendars = get(server, user, 'ui.disableCalendars');

  /* NEW RESTRICTIONS */

  const disableCorporateReports = get(server, user, 'ui.disableCorporateReports');
  const disableDeviceEditInfo = get(server, user, 'ui.disableDeviceEditInfo');
  const disableGeofences = get(server, user, 'ui.disableGeofences');
  const disableSavedCommands = get(server, user, 'ui.disableSavedCommands');
  const disableAccount = get(server, user, 'ui.disableAccount');
  const disableNotifications = get(server, user, 'ui.disableNotifications');

  return {
    disableAttributes,
    disableDrivers,
    disableMaintenance,
    disableGroups,
    disableEvents,
    disableComputedAttributes,
    disableCalendars,

    disableCorporateReports,
    disableDeviceEditInfo,
    disableGeofences,
    disableSavedCommands,
    disableAccount,
    disableNotifications,
  };
});
